module.exports = __webpack_public_path__ + "img/swiper_01.fe9a679f.jpg";